<template>
  <b-col class="m-auto text-center align-items-center">
    <img
      src="../../assets/login/mail_amarelo.svg"
      alt="Envelope com carta"
      class="w-50 mb-4"
    />

    <h2 class="text-tertiary">
      <span class="medium">{{
        resources.page.login.new.successPage.title
      }}</span>
    </h2>

    <br />

    <h5 class="text-white">
      {{ resources.page.login.new.stripePage.ps }}
    </h5>

    <br />

    <h5 class="text-tertiary">axel@teamculture.com.br</h5>
  </b-col>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    resources: 'resources',
  }),
}
</script>
